<template>
    <div class="three-join-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 p-0">
                    <div class="join-item">
                        <h3>Join A Cavo Of Change</h3>
                        <a class="cmn-banner-btn" href="#" target="_blank">
                            Career Opportunity
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-6 p-0">
                    <div class="join-item join-two">
                        <h3>Join As Community Member</h3>
                        <a class="cmn-banner-btn" href="#" target="_blank">
                            Join Community
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Join'
}
</script>